import QuitaDelete from './QuitaDelete'
export {QuitaDelete}
export default QuitaDelete
